import i18n from '@/i18n';

import type {
	FollowingBaseInput,
	FollowingLineGeneratorResult,
} from '@/components/following/types';

import { createReadonlyLabelSegment } from './segmentFactory';

export enum PriseDeContactType {
	CALL = 'CALL',
	VOICE_MESSAGE = 'VOICE_MESSAGE',
	SMS = 'SMS',
	MAIL = 'MAIL',
	AGENCY_VISIT = 'AGENCY_VISIT',
}

const CONTACT_TYPE_ICON: Record<PriseDeContactType, string> = {
	[PriseDeContactType.CALL]: 'phone',
	[PriseDeContactType.VOICE_MESSAGE]: 'record-mail',
	[PriseDeContactType.SMS]: 'message',
	[PriseDeContactType.MAIL]: 'mail',
	[PriseDeContactType.AGENCY_VISIT]: 'agency-arrow-left',
};

export interface PriseDeContactFollowingInput extends FollowingBaseInput {
	type: PriseDeContactType;
	comment?: string;
}

/**
 * Builds FollowingLine props for a "prise de contact" (outreach) event.
 * Each contact type maps to a distinct icon and label.
 */
export const buildFollowingLinePriseDeContact = (
	input: PriseDeContactFollowingInput
): FollowingLineGeneratorResult => {
	return {
		icon: CONTACT_TYPE_ICON[input.type],
		segments: [
			createReadonlyLabelSegment(
				i18n.global.t(`following.labels.priseDeContact.${input.type}`)
			),
		],
		content: input.comment,
		detail: input.detail,
	};
};
